// extracted by mini-css-extract-plugin
export default {"container":"Description_container__wQZcK","description":"Description_description__B4SaR","image":"Description_image__oV6Wb"};